export const DB_posts_URL = "https://blog-website-db-url.onrender.com/posts";
export const DB_users_URL = "https://blog-website-db-url.onrender.com/user";
export const DB_admin_URL = "https://blog-website-db-url.onrender.com/admin";